import * as Schema from "effect/Schema";
import { ProviderInstanceId } from "./providerInstance.ts";
import { ThreadId } from "./baseSchemas.ts";

/** Safe native diagnostic fields; configuration and arbitrary provider errors never cross this seam. */
export const McpServerObservation = Schema.Struct({
  name: Schema.String,
  state: Schema.Literals(["connected", "failed", "pending", "disabled", "unknown"]),
  toolCount: Schema.Number,
});
export type McpServerObservation = typeof McpServerObservation.Type;
export const McpSessionObservation = Schema.Struct({
  instanceId: ProviderInstanceId,
  threadId: ThreadId,
  observedAt: Schema.String,
  stale: Schema.Boolean,
  servers: Schema.Array(McpServerObservation),
});
export type McpSessionObservation = typeof McpSessionObservation.Type;
export const McpObservations = Schema.Array(McpSessionObservation);
export const McpObservationInput = Schema.Struct({ instanceId: ProviderInstanceId });
export class McpObservationError extends Schema.TaggedErrorClass<McpObservationError>()(
  "McpObservationError",
  {
    message: Schema.String,
  },
) {}

export const McpConnectionTestInput = Schema.Struct({
  name: Schema.String,
  revision: Schema.Int.check(Schema.isGreaterThanOrEqualTo(0)),
});
export type McpConnectionTestInput = typeof McpConnectionTestInput.Type;
export const McpConnectionTestResult = Schema.Struct({
  toolCount: Schema.Int.check(Schema.isGreaterThanOrEqualTo(0)),
});
export type McpConnectionTestResult = typeof McpConnectionTestResult.Type;
